module.exports = __webpack_public_path__ + "img/实况预报拼接.5b051493.png";